module.exports = __webpack_public_path__ + "img/Posterwalk-LOGO_Schwarz.6af5ef93.jpg";